/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ID } from '@gh/common-shared-data';
import {
  AbstractRestService,
  identity,
  none,
  RequestMethod,
  RestSettings,
  SlicedDataSource,
} from '@gh/core-data';
import { Observable } from 'rxjs';
import { CommunicationListItemDto } from './communication.dto';
import { CommunicationListItemMapper } from './communication.mapper';

@Injectable()
export class CommunicationRestService extends AbstractRestService {
  constructor(settings: RestSettings) {
    super(settings);
  }

  get(communicationId: ID): Observable<CommunicationListItemDto> {
    return this.httpGet(`${this.bp}/communications/${communicationId}`, CommunicationListItemMapper);
  }

  getSms(): SlicedDataSource<any> {
    return this.createSlicedDataSource({
      method: RequestMethod.Get,
      url: `${this.bp}/communications/sms-messages`,
      body: {},
      requestMapper: none(),
      responseMapper: identity(),
    });
  }

  getSmsList(filter: any): SlicedDataSource<any> {
    return this.createSlicedDataSourceGet(
       `${this.bp}/communications/messages/list`,
       filter,
       identity(),
       identity(),
    );
  }

  setSmsAsRead(communicationId: ID): Observable<CommunicationListItemDto> {
    return this.httpPut(`${this.bp}/communications/read/${communicationId}`, {}, none(), CommunicationListItemMapper);
  }

  markMessagesReadOrUnread(filter: any): Observable<any> {
    return this.httpPut(`${this.bp}/communications/messages/read-status`, filter, identity(), none());
  }

  replySms(sms: any): Observable<any> {
    return this.httpPost(`${this.bp}/communications/reply-sms`, sms, identity(), identity());
  }

  sendLeadSms(sms: CommunicationListItemDto): Observable<CommunicationListItemDto> {
    return this.httpPost(`${this.bp}/communications/send-sms`, sms, CommunicationListItemMapper, CommunicationListItemMapper);
  }

  sendLeadEmail(email: CommunicationListItemDto): Observable<CommunicationListItemDto> {
    return this.httpPost(`${this.bp}/communications/send-email`, email, CommunicationListItemMapper, CommunicationListItemMapper);
  }

  sendContactSms(sms: CommunicationListItemDto): Observable<CommunicationListItemDto> {
    return this.httpPost(`${this.bp}/contacts/send-sms`, sms, CommunicationListItemMapper, CommunicationListItemMapper);
  }

  sendContactEmail(email: CommunicationListItemDto): Observable<CommunicationListItemDto> {
    return this.httpPost(`${this.bp}/contacts/send-email`, email, CommunicationListItemMapper, CommunicationListItemMapper);
  }
}
